// ─────────────────────────────────────────────────────────────────────────────
// inviteData.js — static option lists + the review view-model. This is the one
// place the wizard's presentational defaults live (policy / auth strings the
// stepped form doesn't collect yet), so wiring more of them to the backend later
// is a single-file change.
// ─────────────────────────────────────────────────────────────────────────────

export const STEPS = [
  { id: 1, label: "User Details" },
  { id: 2, label: "Role & Access" },
  { id: 3, label: "Review & Send" },
];

export const TEAM_OPTIONS = [
  "Security", "Engineering", "Marketing", "IT Operations", "Compliance",
];

// Roles shown both in the <select> and as descriptive cards below it.
export const ROLE_OPTIONS = [
  { value: "Admin",          description: "Full access to manage users, policies, and nodes" },
  { value: "Security Admin", description: "Manage security policies and compliance" },
  { value: "IT Manager",     description: "Node management and monitoring access" },
  { value: "Auditor",        description: "Read-only access to compliance and audit logs" },
  { value: "User",           description: "Standard access to assigned resources" },
];

// Initials for the review avatar (falls back to the email's first letters).
export function inviteInitials({ firstName, lastName, email }) {
  const a = (firstName || "").trim();
  const b = (lastName || "").trim();
  if (a || b) return `${a[0] || ""}${b[0] || ""}`.toUpperCase() || "?";
  const handle = (email || "").split("@")[0];
  return (handle.slice(0, 2) || "?").toUpperCase();
}

// The 2×2(+1) summary grid on the Review step. Team/Role come straight from the
// form; the rest are sensible defaults surfaced for review (not yet collected).
export function buildReviewRows(form) {
  return [
    { key: "Team",          value: form.team || "—" },
    { key: "Role",          value: form.role || "—" },
    { key: "Policy",        value: "Strict Security" },
    { key: "MFA",           value: form.requireMfaSetup ? "Required" : "Optional" },
    { key: "Auth",          value: "Password + MFA" },
    { key: "Welcome Email", value: form.sendWelcomeEmail ? "Yes" : "No" },
  ];
}
